import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Certification from "./tabs/Certification";
import { Wrapper } from "../styled";

const certificationsTabs = [
  {
    title: "Сертификация",
    component: <Certification />,
  }
];

const Certifications: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {certificationsTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {certificationsTabs[tab].component}
    </Wrapper>
  );
};

export default Certifications;
